import { render, staticRenderFns } from "./DraftDocuments.vue?vue&type=template&id=4b292d4c&"
import script from "./DraftDocuments.vue?vue&type=script&lang=js&"
export * from "./DraftDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports